"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constrained = void 0;
/**
 * Constrained variant. A variant where each form abides by a given constraint - handles these
 * inputs and provides these outputs.
 *
 * This can be used to ensure optional properties exist on the union type.
 * @param _constraint_
 * @param v
 * @returns
 */
function constrained(_constraint_, v) {
    return v;
}
exports.constrained = constrained;
